export class QueryResultsModel<T = any> {
    items: T[];
    totalCount: number;
    totalSum: number;
    errorMessage: string;

    constructor(
        items: T[] = [],
        totalCount: number = 0,
        errorMessage: string = "",
        totalSum?: number,

) {
        this.items = items;
        this.totalCount = totalCount;
        this.totalSum = totalSum;
    }
}
